import { MapMarkerRightIcon } from './MapMarkerRightIcon';

/**
 * author: Michael Irigoyen
 * id 445C4B6D-5A56-42F3-845F-92C22A11BB64
 * name map-marker-right
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-right.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationRightIcon = MapMarkerRightIcon;
export default LocationRightIcon